<template>
  <div>
    <ViaticTable :status_viatic="getStatusViatic"/>
  </div>
</template>

<script>
import ViaticTable from "@/views/monitoring/views/viatic/components/ViaticTable.vue";
export default {
  components: {
    ViaticTable,
  },
  data() {
    return {};
  },
  computed:{
    getStatusViatic(){
      return this.$route.meta.status_viatic;
    }
  }
};
</script>

<style>
</style>